import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// Zone-based change detection is stated explicitly rather than relied on as a
// default. This app is deeply coupled to it — 486 setTimeout calls, 365
// detectChanges calls and only 9 OnPush components out of 369 — so zoneless is
// a separate project, not a migration step.
platformBrowserDynamic()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
  .catch(err => console.error(err));
